import * as joint from '@joint/plus';

export function addElementsAndLink(service) {
  const rect1 = new joint.shapes.standard.Rectangle();
  rect1.position(100, 30);
  rect1.resize(100, 40);
  rect1.attr({ body: { fill: 'blue' }, label: { text: 'Rectangle 1', fill: 'white' } });

  const rect2 = new joint.shapes.standard.Rectangle();
  rect2.position(300, 30);
  rect2.resize(100, 40);
  rect2.attr({ body: { fill: 'green' }, label: { text: 'Rectangle 2', fill: 'white' } });

  service.graph.addCells([rect1, rect2]);

  const link = new joint.shapes.standard.Link();
  link.source(rect1);
  link.target(rect2);
  service.graph.addCell(link);
}

export function listSubFunctions(service) {
  const elements = service.graph.getElements();
  const mapped = elements.map((el) => ({
    id: el.id,
    type: el.get('type'),
    label: el.attr('label/text'),
    position: el.position(),
    size: el.size(),
  }));
  return mapped.map((sf) => ({
    value: sf.id,
    content: sf.label || `ID: ${sf.id}`,
  }));
}

export function applyOnSelection(service, method) {
  service.graph.startBatch('selection');
  service.selection.collection.models.forEach((model) => model[method]());
  service.graph.stopBatch('selection');
}

export function changeSnapLines(service, checked) {
  checked ? service.snaplines.enable() : service.snaplines.disable();
}
